type MerchantCardProps = {
  name?: string;
  image?: string;
  alt?: string;
};

const MerchantCard = ({
  name,
  image,
  alt = 'merchant logo',
}: MerchantCardProps) => {
  const safeName = name?.trim() || 'Unknown merchant';
  const initials = safeName
    .split(' ')
    .map((n) => n[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return (
    <div className="flex items-center gap-3">
      <div
        className="
          w-[46px] h-8 
          flex items-center justify-center
          border border-[#F2F4F7] 
          rounded-md 
          overflow-hidden 
          bg-white
        "
      >
        {image ? (
          <img
            src={image}
            alt={safeName || alt}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="text-xs font-medium text-gray-500">{initials}</span>
        )}
      </div>

      <span className="text-sm font-medium text-[#101828]">{name}</span>
    </div>
  );
};

export default MerchantCard;
